'use client';

import { Drawer } from '@/shared-ui/molecules/drawer';
import type { ShopperProducts } from '@/scapi';
import { MenuDrawerContent } from '@/features/menu-drawer-content';

type DrawerContentProps = {
    rootCategory?: Promise<ShopperProducts.schemas['Category']>;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const DrawerContent = ({ rootCategory, open, onOpenChange }: DrawerContentProps) => {
    return (
        <Drawer.Content
            variant="left"
            title="Navigation menu"
            overlayClassName="z-[60] bg-black/50"
            className="z-[60] flex h-full max-w-[390px] w-[calc(100%-48px)] flex-col gap-0 overflow-visible md:w-[390px]">
            <Drawer.CloseButton aria-label="Close menu" variant="left" />
            <nav className="flex min-h-0 flex-1 flex-col overflow-hidden" aria-label="Menu panel">
                <MenuDrawerContent resolve={rootCategory} open={open} onOpenChange={onOpenChange} />
            </nav>
        </Drawer.Content>
    );
};
